import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { EventService } from '../../../services/event/event.service';
import { WizardService } from '../../../services/wizard/wizard.service';
import { IWizardPage, IWizardAction, WizardNextPage, WizardActionTrackingEvent } from 'common-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wizard-actions',
    templateUrl: './wizard-actions.component.html',
    styleUrls: ['../../../wizard.component.scss', './wizard-actions.component.scss']
})
export class WizardActionsComponent implements OnInit {
    @Input() currentPage: IWizardPage;
    @Input() actions?: IWizardAction[];
    @Output() onHandleCancel = new EventEmitter<WizardNextPage>();
    @Output() onTrackEvent = new EventEmitter<WizardActionTrackingEvent>();
    public labels = { back: 'Back', cancel: 'Cancel', next: 'Next' };
    public isBackVisible = true;
    public isCancelVisible = true;
    private actionLabel$: Subscription;

    constructor(public eventService: EventService, private wizardService: WizardService) {}

    ngOnInit() {
        this.isBackVisible = false;
        this.isCancelVisible = !this.wizardService.config.isPlugin;

        this.actionLabel$ = this.eventService.onUpdateActionLabel$.subscribe((label: string) => {
            this.labels.next = label;
        });
    }

    ngOnDestroy() {
        this.actionLabel$.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        const { currentValue } = changes.currentPage;

        if (currentValue && currentValue.end) {
            this.isBackVisible = false;
            this.isCancelVisible = false;
            return;
        }

        if (currentValue && currentValue.step > 1) {
            this.isBackVisible = true;
        } else {
            this.isBackVisible = false;
        }
    }

    handleNext(nextAction: IWizardAction) {
        this.labels.next = null;

        if (nextAction.mixpanel) {
            const { action, app, data } = nextAction.mixpanel;

            this.onTrackEvent.emit({ action, app, data });
        }

        /** Can we make this even more generic by syncing with fields on the server? */
        switch (nextAction.nextPage) {
            case 'home':
                this.onHandleCancel.emit();
                break;
            case 'tasks.active':
                this.onHandleCancel.emit('tasks.active');
                break;
            case 'tasks.upcoming':
                this.onHandleCancel.emit('tasks.upcoming');
                break;
            default:
                this.eventService.handleNextAction(nextAction);
        }
    }

    handleBack() {
        this.labels.next = null;
        this.eventService.handlePageChange('back', null);
    }

    handleCancel() {
        this.onHandleCancel.emit();
    }
}
